import { createApp } from 'vue';
import { FontAwesomeIcon } from '@alchemer/vue-component-library';
import { createAuth0 } from '@auth0/auth0-vue';

import App from './App.vue';

import './assets/main.css';
import '@alchemer/vue-component-library/component.css';
import { EnvironmentalConfig } from '@/utils/environmental-config';
import { EnvironmentalConfigKey } from '@/utils/environmental-config';

const app = createApp(App);

app.component('FontAwesomeIcon', FontAwesomeIcon);

// parse the environmental config and provide it to the app
// components can access the variable using inject('environmentalConfig')
const environmentalConfig = new EnvironmentalConfig();
app.provide(EnvironmentalConfigKey, environmentalConfig)

app.config.errorHandler = (err, vm, info) => {
  console.error('Error:', err);
  console.error('Vue component:', vm);
  console.error('Additional info:', info);
};

app.use(
  createAuth0({
    domain: import.meta.env.VITE_AUTH0_DOMAIN,
    clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
    authorizationParams: {
      redirect_uri: window.location.origin,
      audience: import.meta.env.VITE_AUTH0_AUDIENCE
    },
  }),
);

app.mount('#app');
